import { Input } from "components/Input";
import { Row, Col, Separator } from "styles";

export function Customer(props) {
  const places = [
    "China",
    "América Latina",
    "América do Norte",
    "Europa",
    "Russia",
    "Oriente Médio",
    "Japão",
  ];

  const placeHandler = (value, place) => {
    const copyHeavyBroiler = { ...props.heavyBroiler };
    if (value) {
      copyHeavyBroiler.exportPlaces.push(place);
    } else {
      const index = copyHeavyBroiler.exportPlaces.findIndex(
        (item) => item === place
      );
      if (index > -1) {
        copyHeavyBroiler.exportPlaces.splice(index, 1);
      }
    }
    props.setHeavyBroiler(copyHeavyBroiler);
  };

  return (
    <>
      <Row>
        <Col>
          <Input
            type="input"
            params="accommodations"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            inputType="number"
            label="Número de Alojamentos"
          />
        </Col>
        <Col>
          <Input
            type="select"
            params="healthScore"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Escore sanitário"
            placeholder="Selecione o escore"
            options={props.config
              .filter((item) => item.key === "customerHealthScore")
              .map((item) => ({ value: item.description }))}
          />
        </Col>
        <Col>
          <Input
            type="input"
            params="healthChallenge"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Quais os desafios sanitários?"
          />
        </Col>
        <Col>
          <Input
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            params="date"
            type="inputMask"
            label="Data Alteração"
            mask="99/99/9999"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="input"
            params="knownAgents"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Os agentes são conhecidos? Se sim, quais são?"
          />
        </Col>
        <Col>
          <Input
            type="select"
            params="antibiogramRecent"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Foi feito antibiograma recentemente?"
            placeholder="Selecione uma opção"
            options={[
              { value: "Sim", label: "Sim" },
              { value: "Não", label: "Não" },
            ]}
          />
        </Col>
      </Row>
      <Separator />
      <Row>
        <Col flexRow>
          <Input
            type="checkbox"
            params="export"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Exportador"
          />
          <Input
            type="checkbox"
            params="internMarket"
            item={props.heavyBroiler}
            setItem={props.setHeavyBroiler}
            label="Mercado Interno"
          />
        </Col>
      </Row>
      {props.heavyBroiler.export ? (
        <div style={{ paddingTop: "35px" }}>
          {places.map((place) => (
            <Input
              key={place}
              type="checkbox"
              label={place}
              onChange={(e) => placeHandler(e.target.checked, place)}
              checked={
                props.heavyBroiler.exportPlaces.findIndex(
                  (item) => item === place
                ) > -1
              }
            />
          ))}
        </div>
      ) : null}
    </>
  );
}
